export const SQ_METER_SIGN = "м²";
export const RUBLE_SIGN = '₽';
export const AUTH_CODE_RESEND_TIMEOUT = 60;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const SENTRY_TRACING = import.meta.env.VITE_SENTRY_TRACING;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;
export const YANDEX_METRICS_ACCOUNT = Number(import.meta.env.VITE_YANDEX_METRICS_ACCOUNT);
